Vue.component('client-plusvibe', {
	props: ['client-id'],

	data () {
		return {
			loading: false,

			campaigns: [],

			add: {
				id: '',
				name: '',
				start_date: '',
			},

			alert: null,
		};
	},

	mounted () {
		this.fetchCampaigns();
	},

	methods: {
		fetchCampaigns () {
			this.loading = true;

			axios.get('/api/client-plusvibe-campaigns', {
				params: {
					client_id: this.clientId
				}
			})
				.then((response) => {
					this.campaigns = response.data;
					this.loading = false;
				});
		},

		onCampaignChange (e) {
			const opt = e.target.selectedOptions[0];
			this.add.name = opt ? opt.text.trim() : '';
			this.add.start_date = opt.dataset['startDate'];
		},

		handleAdd () {
			if (!this.add.id) {
				return;
			}

			this.campaigns.push(this.add);

			this.add = {
				id: '',
				name: '',
				start_date: '',
			};
		},

		handleSave () {
			this.loading = true;

			const campaigns = this.campaigns.filter(e => e.id.length > 0);

			axios.post('/api/client-plusvibe-campaigns/save', {
				campaigns
			}, {
				params: {
					client_id: this.clientId
				}
			})
			.then((response) => {
				this.alert = {
					type: 'success',
					message: 'Settings have been saved'
				};

				this.loading = false;
			})
			.catch((response) => {
				this.alert = response.data;
			});
		},

		handleDeleteRow(key) {
			this.campaigns.splice(key, 1);
		},
	}
});